import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { DetailsContactInfoComponent } from './details-contact-info.component';

@NgModule({
	declarations: [DetailsContactInfoComponent],
	imports: [CommonModule, TranslateModule.forChild()],
	exports: [DetailsContactInfoComponent],
})
export class DetailsContactInfoModule {}
